import { Hashtag, Profile, Receipt1, Send } from "iconsax-reactjs";
import React from "react";
import { GoCheck } from "react-icons/go";

const defaultSteps = [
    { icon: <Hashtag />, label: "Amount" },
    { icon: <Profile />, label: "Recipient" },
    { icon: <Receipt1 />, label: "Review" },
    { icon: <Send />, label: "Send" },
];

const PaymentStepper = ({ currentStep = 0, completedSteps }) => {
    const steps = defaultSteps;
    const activeStep = currentStep;
    const isComplete = (index) =>
        Array.isArray(completedSteps) ? completedSteps.includes(index) : index < activeStep;
    const isConnectorComplete = (index) =>
        Array.isArray(completedSteps)
            ? isComplete(index) && isComplete(index + 1)
            : index < activeStep;

    return (
        <div className="flex items-center w-full mb-8">
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                    {/* Step icon */}
                    <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center text-xl shrink-0
                            ${
                                isComplete(index)
                                    ? "bg-[#EBE4FF] text-[#6F00FF]"
                                    : index === activeStep
                                      ? "bg-[#A173FF] text-[#FBFAFF]"
                                      : "bg-[#EFF0FB] text-[#6F739B]"
                            }`}
                    >
                        {isComplete(index) ? <GoCheck /> : step.icon}
                    </div>

                    {/* Connector line */}
                    {index < steps.length - 1 && (
                        <div
                            className={`flex-grow h-px mx-2 transition-all duration-300 ${
                                isConnectorComplete(index) ? "bg-[#E9D7FE]" : "bg-[#EAECF0]"
                            }`}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PaymentStepper;
